"use client"
import "./benefit-bar.css"
import { styled } from "@mui/system";
import UKDialog from "@/components/UKDialog";
import CloseIcon from "@mui/icons-material/Close";
import React, { useEffect, useState } from "react";
import { DialogTitle, IconButton, DialogContent } from "@mui/material";

interface BenefitProp {
  open: boolean;
  title: string;
  content: string;
  closeFn: () => void;
}

const CustomerDialogContent = styled(DialogContent)({
  height: "493.5px",
  padding: "0 24px",
  marginBottom: "24px",
  overflowY: "auto",
  "&::-webkit-scrollbar": {
    width: "8px",
  },
  "&::-webkit-scrollbar-track": {
    background: "#fff",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "rgba(0, 0, 0, 0.14)",
    borderRadius: "4px",
    cursor: "pointer",
  },
  "&::-webkit-scrollbar-thumb:hover": {
    backgroundColor: "rgba(0, 0, 0, 0.28)",
  },
});

const BenefitDialog = ( { open, title, content, closeFn }: BenefitProp ) => {

  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    setIsOpen(open);
  }, [open])

  const handleClose = () => {
    setIsOpen(false);
    closeFn && closeFn();
  }

  return (
    <UKDialog
      open={isOpen}
      onClose={handleClose}
      showCloseBtn={false}
      sx={{
        "& .MuiDialog-paper": {
          width: "592px",
          maxWidth: "none",
          borderRadius: "12px",
        },
      }}
    >
      <DialogTitle
        sx={{
          height: 64,
          padding: "0 24px",
          fontSize: 16,
          fontWeight: "bold",
          display: "flex",
          alignItems: "center",
        }}
      >
        {title}
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={(theme) => ({
          position: "absolute",
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}
      >
        <CloseIcon />
      </IconButton>
      <CustomerDialogContent>
        <div dangerouslySetInnerHTML={{ __html: content }} className="benefit-rich-content"></div>
      </CustomerDialogContent>
    </UKDialog>
  );
};

export default BenefitDialog;
